module.exports = __webpack_public_path__ + "img/closeIcon.69219aca.svg";